
const CommonUtil = {
  getCurrentHostname () {
    return window.location.hostname
  },
  gotoUrl (url) {
    window.location.href = url
  },
  openUrl (url) {
    window.open(url)
  }
}

export default CommonUtil



// WEBPACK FOOTER //
// ./src/common/CommonUtil.js